/* eslint-disable */
import React, { useState, useMemo } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Box from '@mui/material/Box';
import {
  TableSortLabel,
  Button,
  IconButton,
  Snackbar,
  Alert,
  Dialog,
} from '@mui/material';
import _ from 'lodash';
import { visuallyHidden } from '@mui/utils';
import { useNavigate } from 'react-router-dom';
import { getStorage } from '../../utils/functions/localstorage';
import Swal from 'sweetalert2';
import api from '../../utils/functions/api';
import addCommas from '../../utils/functions/commas';
import dayjs from 'dayjs';

import QRCode from '../../components/PayOptionE-Entry/QRCode';
import QRCredit from '../../components/PayOptionE-Entry/QRCredit';

import DeleteIcon from '@mui/icons-material/Delete';
import QrCodeIcon from '@mui/icons-material/QrCode';
import LinkIcon from '@mui/icons-material/Link';

import { ROLES } from '../../utils/constants';
import { checkAccessRights } from '../../utils/functions/accessRight';

const columns = [
  { id: 'company_name', label: 'ชื่อร้านค้า', align: 'center' },
  { id: 'customer_name', label: 'ชื่อลูกค้า', align: 'center' },
  { id: 'order_id', label: 'เลขอ้างอิงรายการของร้านค้า', align: 'center' },
  { id: 'createdAt', label: 'วันสร้างรายการ', align: 'center' },
  { id: 'transaction_date', label: 'วันที่ชำระเงิน', align: 'center' },
  { id: 'payment_ref_id', label: 'เลขอ้างอิงรายการชำระเงิน', align: 'center' },
  { id: 'description', label: 'จดบันทึก', align: 'center' },
  { id: 'amount', label: 'ยอดเงินชำระ', align: 'center' },
  { id: 'payment_type', label: 'ช่องทางการชำระเงิน', align: 'center' },
  { id: 'createdBy', label: 'ชื่อผู้สร้าง', align: 'center' },
  { id: 'status', label: 'สถานะ', align: 'center' },
  { id: 'edit', label: '', align: 'center' },

  // ใช้ Spread operator กระจายค่าใน Array ถ้าเงื่อนไขเป็นจริง
  // ถ้าเงื่อนไขเป็นเท็จ จะกระจาย Array ว่าง [] ซึ่งไม่ส่งผลอะไร
  ...(checkAccessRights(ROLES.SUPER_ADMIN_ROLE)
    ? [{ id: 'actions', label: '', align: 'center' }]
    : []),
];

function TableHistory({
  ishistory,
  handleRequestSort,
  orderDirection,
  valueToOrderBy,
  pagination,
  handlePaginationChange,
}) {
  const paginatedData = ishistory; // ไม่ต้อง slice ถ้า data ถูก filter มาจาก backend แล้ว

  console.log('ishistory', ishistory);
  const navigate = useNavigate();

  const [openQRModal, setOpenQRModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleOpenQRModal = (row) => {
    setSelectedRow(row);
    setOpenQRModal(true);
  };

  const handleCloseQRModal = () => {
    setSelectedRow(null);
    setOpenQRModal(false);
  };

  const createSortHead = (property) => (event) => {
    handleRequestSort(event, property);
  };

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  //   handlePaginationChange('handleChangePage', newPage + 1);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  //   handlePaginationChange('handleChangeRowsPerPage', event.target.value);
  // };

  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  const handleCopyLink = () => {
    if (row.link_payment) {
      navigator.clipboard.writeText(row.link_payment);
      setOpenSnackbar(true);
    }
  };

  const handleDeleteTransaction = async (row) => {
    const result = await Swal.fire({
      title: 'คุณแน่ใจหรือไม่?',
      text: 'คุณต้องการลบรายการนี้หรือไม่',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'ลบ',
      cancelButtonText: 'ยกเลิก',
    });

    if (!result.isConfirmed) return;

    try {
      const path = `${process.env.REACT_APP_APIHOST}/eentry/orderpayment/transactions/${row.id}`;
      await api.delete(path, {
        headers: { Authorization: getStorage('token') },
      });

      const confirm = await Swal.fire({
        title: 'ลบสำเร็จ!',
        text: 'รายการถูกลบเรียบร้อยแล้ว',
        icon: 'success',
        confirmButtonText: 'ตกลง',
      });

      if (confirm.isConfirmed) {
        window.location.reload();
      }
    } catch (e) {
      console.error('ลบไม่สำเร็จ', e);
      Swal.fire('เกิดข้อผิดพลาด', 'ไม่สามารถลบรายการได้', 'error');
      throw new Error(e);
    }
  };

  return (
    <>
      <TableContainer sx={{ maxHeight: 460, overflowY: 'auto' }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, color: '#fff' }}
                >
                  <TableSortLabel
                    active={valueToOrderBy === column.id}
                    direction={
                      valueToOrderBy === column.id
                        ? _.toLower(orderDirection)
                        : _.toLower('asc')
                    }
                    onClick={createSortHead(column.id)}
                  >
                    {column.label}
                    {valueToOrderBy === column.id ? (
                      <Box component="span" sx={visuallyHidden}>
                        {orderDirection === 'desc'
                          ? 'sorted descending'
                          : 'sorted ascending'}
                      </Box>
                    ) : null}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {_.size(paginatedData) ? (
            <TableBody>
              {paginatedData.map((row, index) => (
                <TableRow
                  key={index}
                  // sx={{
                  //   '&:last-child td, &:last-child th': { border: 0 },
                  // }}
                  // className="hover:bg-gray-200 cursor-pointer"
                >
                  <TableCell align="center">
                    {row.company_name ? row.company_name : '-'}
                  </TableCell>
                  <TableCell align="center">
                    {row.customer_name ? row.customer_name : '-'}
                  </TableCell>
                  <TableCell align="center">
                    {row.order_id ? row.order_id : '-'}
                  </TableCell>
                  <TableCell align="center">
                    {row.createdAt
                      ? dayjs(row.createdAt).format('DD-MM-YYYY')
                      : '-'}
                  </TableCell>
                  <TableCell align="center">
                    {row.transaction_date
                      ? dayjs(row.transaction_date).format('DD-MM-YYYY')
                      : '-'}
                  </TableCell>
                  <TableCell align="center">
                    {row.payment_ref_id ? addCommas(row.payment_ref_id) : '-'}
                  </TableCell>
                  <TableCell align="center">
                    {row.description ? row.description : '-'}
                  </TableCell>
                  <TableCell align="center">
                    {row.amount ? row.amount : '-'}
                  </TableCell>
                  <TableCell align="center">
                    {row.payment_type === 'Cashier'
                      ? 'Link'
                      : row.payment_type || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {row.createdBy ? row.createdBy : '-'}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color:
                        row.payment_status === 'success'
                          ? 'green'
                          : row.payment_status === 'fail'
                            ? 'red'
                            : row.payment_status === 'canceled'
                              ? '#FFA500' // สีเหลืองออกส้ม (orange)
                              : 'gray',
                    }}
                  >
                    {row.payment_status ? row.payment_status : '-'}
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      onClick={() => {
                        if (row.qrcode_image) handleOpenQRModal(row);
                      }}
                      disabled={!row.qrcode_image}
                      sx={{
                        color: row.qrcode_image
                          ? '#1976D2'
                          : 'rgba(0,0,0,0.26)',
                        '&:hover': {
                          color: row.qrcode_image
                            ? '#1565C0'
                            : 'rgba(0,0,0,0.26)',
                        },
                      }}
                    >
                      <QrCodeIcon />
                    </IconButton>

                    <IconButton
                      onClick={() => {
                        if (row.link_payment) {
                          navigator.clipboard.writeText(row.link_payment);
                          setOpenSnackbar(true);
                        }
                      }}
                      disabled={
                        !row.link_payment || row.payment_status === 'cenceled'
                      }
                      sx={{
                        color: row.link_payment
                          ? '#1976D2'
                          : 'rgba(0,0,0,0.26)',
                        '&:hover': {
                          color: row.link_payment
                            ? '#1565C0'
                            : 'rgba(0,0,0,0.26)',
                        },
                      }}
                    >
                      <LinkIcon />
                    </IconButton>
                  </TableCell>
                  {checkAccessRights(ROLES.SUPER_ADMIN_ROLE) && (
                    <TableCell align="center">
                      <IconButton
                        onClick={() => {
                          if (row.payment_status === 'unpaid') {
                            handleDeleteTransaction(row);
                          }
                        }}
                        disabled={row.payment_status !== 'unpaid'}
                        sx={{
                          color:
                            row.payment_status === 'unpaid'
                              ? '#D32F2F'
                              : 'rgba(0,0,0,0.26)',
                          '&:hover': {
                            color:
                              row.payment_status === 'unpaid'
                                ? '#B71C1C'
                                : 'rgba(0,0,0,0.26)',
                          },
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  <div>ไม่มีข้อมูล</div>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={pagination.totalItems}
        rowsPerPage={pagination.size}
        page={pagination.currPage - 1} // MUI ใช้ index เริ่มที่ 0
        onPageChange={(event, newPage) => {
          handlePaginationChange('handleChangePage', newPage + 1);
        }}
        onRowsPerPageChange={(event) => {
          handlePaginationChange(
            'handleChangeRowsPerPage',
            parseInt(event.target.value, 10),
          );
        }}
      />

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: '100%' }}
        >
          คัดลอกลิงก์แล้ว!
        </Alert>
      </Snackbar>
      <Dialog
        open={openQRModal}
        onClose={handleCloseQRModal}
        maxWidth="md"
        fullWidth
      >
        {selectedRow?.payment_type === 'QR Code' && (
          <QRCode
            qrCodeImage={selectedRow.qrcode_image}
            paymentRefId={selectedRow.payment_ref_id}
            payment_token={selectedRow.payment_token}
            orderId={selectedRow.order_id}
          />
        )}
        {selectedRow?.payment_type === 'QR Code Credit Card' && (
          <QRCredit
            qrCodeImage={selectedRow.qrcode_image}
            paymentRefId={selectedRow.payment_ref_id}
            payment_token={selectedRow.payment_token}
            orderId={selectedRow.order_id}
          />
        )}
      </Dialog>
    </>
  );
}

export default TableHistory;
